module.exports = __webpack_public_path__ + "img/characterAnime22.94487878.png";